<div class="inner">
  <div class="info">
    <h1 class="title">{{ title }}</h1>

    <div #sessionIdAnchor>
      <button class="sessionId" (click)="handleSessionIdClick()">
        <qai-icon kind="copy" size="16px" />
        <span class="label">{{'call.COPY_SESSION_ID_BUTTON' | transloco}}</span>
      </button>
    </div>
    <qai-tooltip
      [qaiFloating]="sessionIdAnchor"
      placement="below-center"
      [events]="['click']"
    >
      {{ 'call.SESSION_ID_COPIED' | transloco }}
    </qai-tooltip>
  </div>

  <div class="controls">
    <ng-content select="app-call-controls, app-visual-aid-call-controls" />
  </div>
</div>
